
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface ErrorStateProps {
  onAddProvider: () => void;
}

export const ErrorState = ({ onAddProvider }: ErrorStateProps) => {
  return (
    <div className="space-y-6">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error loading providers</AlertTitle>
        <AlertDescription>
          There was an error loading the PEO providers. This might be due to a temporary network issue or a database configuration problem.
          <div className="mt-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => window.location.reload()}
            >
              Refresh the page
            </Button>
          </div>
        </AlertDescription>
      </Alert>
      
      <div className="col-span-full py-10 text-center">
        <p className="text-muted-foreground mb-4">You can still try to add a new provider</p>
        <Button 
          onClick={onAddProvider}
          variant="default"
        >
          <Plus className="mr-2 h-4 w-4" />
          Add PEO Provider
        </Button>
      </div>
    </div>
  );
};
